import React, { useState } from 'react';

import { Calendar, Download, Funnel, Search, Users } from 'lucide-react';

import { ISelectOption, Select } from '../../../shared/Selects';
import { TextInput } from '../../../shared/Inputs';

export const Filters = () => {
    const ranges: ISelectOption[] = [
        { value: "7", label: "Last 7 days" },
        { value: "30", label: "Last 30 days" },
        { value: "90", label: "Last 90 days" },
        { value: "custom", label: "Custom Range" },
    ];

    const teams: ISelectOption[] = [
        { value: "all", label: "All Teams" },
        { value: "engineering", label: "Engineering" },
        { value: "sales", label: "Sales" },
        { value: "hr", label: "HR" },
        { value: "finance", label: "Finance" },
        { value: "marketing", label: "Marketing" },
        { value: "executive", label: "Executive" },
    ];

    const departments: ISelectOption[] = [
        { value: "all", label: "All Departments" },
        { value: "engineering", label: "Engineering" },
        { value: "sales", label: "Sales" },
        { value: "hr", label: "HR" },
        { value: "finance", label: "Finance" },
        { value: "marketing", label: "Marketing" },
        { value: "executive", label: "Executive" },
    ];

    const [selectedRange, setSelectedRange] = useState<ISelectOption>(ranges[0]);
    const [selectedTeam, setSelectedTeam] = useState<ISelectOption>(teams[0]);
    const [selectedDepartment, setSelectedDepartment] = useState<ISelectOption>(departments[0]);

    return (
        <div className="dashboard__mbts__filters">
            <div className="dashboard__mbts__filters__left">
                <TextInput
                    icon={{ icon: <Search />, position: 'prefix' }}
                    placeholder="Search"
                />
                <div className="dashboard__mbts__filters__left__sub_grp">
                    <Select
                        postBtnIcon={<Calendar />}
                        selected={selectedRange}
                        options={ranges}
                        onSelect={(option) => setSelectedRange(option)}
                    />
                    <Select
                        postBtnIcon={<Users />}
                        selected={selectedTeam}
                        options={teams}
                        onSelect={(option) => setSelectedTeam(option)}
                    />
                    <Select
                        postBtnIcon={<Funnel />}
                        selected={selectedDepartment}
                        options={departments}
                        onSelect={(option) => setSelectedDepartment(option)}
                    />
                </div>
            </div>
            <div className="dashboard__mbts__filters__right">
                <button className='btn btn--sm btn--radius-sm btn--secondary'>
                    <Download />
                    <span>Download</span>
                </button>
            </div>
        </div>
    );
};